import React from "react";
import Select from "react-select";
import "react-select/dist/react-select.css";

class ReactSelect extends React.Component {
  state = {
    selectedOption: null
  };

  handleChange = selectedOption => {
    this.props.handleSelect(selectedOption, "multi",this.props.state_key);
    this.setState({selectedOption});
  };

  render() {
    const {selectedOption} = this.state;
    const {optionsData} = this.props;
    const options = [];
    optionsData.map(data => {
      options.push({
        value: data.id,
        label: data.name,
        id: data.id,
        key: this.props.state_key
      });
      return data;
    });
    return (
      <Select
        clearable
        value={selectedOption}
        multi
        onChange={this.handleChange}
        options={options}
      />
    );
  }
}

export default ReactSelect;



// WEBPACK FOOTER //
// ./src/views/Dealroom/Dealroom/MultiSelect.js